package org.gymly.api

import kotlinx.browser.window

/**
 * En dev webpack (:18081 JS / :18082 Wasm) llama al backend Spring directo.
 * Evita errores de proxy cuando el dev server no reenvía `/api` correctamente.
 */
actual fun defaultApiBaseUrl(): String {
    val port = window.location.port
    if (port == "18081" || port == "18082") {
        val host = window.location.hostname.ifBlank { "127.0.0.1" }
        return "http://$host:$GYMLY_API_PORT"
    }
    return window.location.origin
}

actual fun currentPageHostname(): String =
    window.location.hostname.lowercase()
